import { DateRange } from 'react-day-picker';
import api from './baseApi';

export const getCoordinates = async ({
  searchTerm,
  status,
  selectedCollector,
  dateRange,
}: {
  searchTerm?: string;
  status?: string;
  selectedCollector?: string;
  dateRange?: DateRange | undefined;
}) => {
  try {
    let query = `?`;
    if (searchTerm) {
      query += `&fullname=${searchTerm}`;
    }

    if (status) {
      // replace spaces with %20
      status = status.replace(/\s+/g, '%20');
      query += `&status=${status}`;
    }

    if (selectedCollector) {
      query += `&collectorId=${selectedCollector}`;
    }

    if (dateRange?.to) {
      // Add one day to the end date
      const endDate = new Date(dateRange.to);
      endDate.setDate(endDate.getDate() + 1);
      query += `&endDate=${endDate.toISOString()}`;
    }

    if (dateRange?.from) {
      query += `&startDate=${dateRange.from.toISOString()}`;
    }

    console.log(query);

    const response = await api.get(`/collection/map-collections${query}`);
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching maps', error);
    return [];
  }
};
